export const BASE_STAFF_PATH = '/staffs';

export const STAFF_CHECK_IN_PATH = `${BASE_STAFF_PATH}/check-in`;
export const STAFF_CHECK_OUT_PATH = `${BASE_STAFF_PATH}/check-out`;
